<kl-form-container
  [title]="title + (mode === 'edit' || mode === 'view' ? entity.username : '')"
  [mode]="mode"
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="validationError || apiError"
  [alertType]="alertType"
  (onCloseAlert)="validationError = false; apiError = false"
  (onCommitSave)="commitSave($event)"
>
  <form #installationUserForm="ngForm" class="modal-form" novalidate>
    <div class="col-md-12 col-sm-12">
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="form-group row">
            <label for="employees_type" class="col-md-4 col-sm-12">
              <small>{{ "status" | translate }}</small>
            </label>
            <div class="col-md-8 col-sm-12">
              <p-dropdown
                [emptyFilterMessage]="'not_found' | translate"
                [disabled]="isReadOnly"
                [options]="[
                  { label: 'ACTIVE' | translate, value: 'ACTIVE' },
                  { label: 'PASSIVE' | translate, value: 'PASSIVE' }
                ]"
                [(ngModel)]="entity.status"
                (onChange)="formChange(true)"
                name="employees_type"
                id="employees_type"
                [style]="{ width: '100%' }"
              >
              </p-dropdown>
            </div>
          </div>
          <div class="form-group row">
            <label for="installation_user_code" class="col-md-4 col-sm-12">
              <small
                >{{ "username" | translate }}
                <i class="text-danger">*</i></small
              >
            </label>
            <div class="col-md-8 col-sm-12">
              <input
                [disabled]="isReadOnly"
                type="text"
                id="installation_user_code"
                name="installation_user_code"
                class="form-control form-control-sm"
                required
                maxlength="50"
                #focusElement
                #username="ngModel"
                [(ngModel)]="entity.username"
                [ngClass]="
                  validationError && username.invalid ? 'errorInput' : ''
                "
              />
              <div
                *ngIf="validationError && username.invalid"
                class="errorMessage"
              >
                {{ "important_area" | translate }}
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="installation_user_name" class="col-md-4 col-sm-12">
              <small
                >{{ "fullname" | translate }}
                <i class="text-danger">*</i></small
              >
            </label>
            <div class="col-md-8 col-sm-12">
              <input
                [disabled]="isReadOnly"
                type="text"
                maxlength="100"
                name="installation_user_name"
                id="installation_user_name"
                #full_name="ngModel"
                required
                [(ngModel)]="entity.full_name"
                [ngClass]="
                  validationError && full_name.invalid ? 'errorInput' : ''
                "
                class="form-control form-control-sm"
              />
              <div
                *ngIf="validationError && full_name.invalid"
                class="errorMessage"
              >
                {{ "important_area" | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="form-group row">
            <label for="installation_user_password" class="col-md-4 col-sm-12">
              <small
                >{{ "password" | translate }}
                <i class="text-danger">*</i></small
              >
            </label>
            <div class="col-md-8 col-sm-12">
              <input
                [disabled]="isReadOnly"
                maxlength="100"
                name="installation_user_password"
                id="installation_user_password"
                #password="ngModel"
                type="password"
                required
                [(ngModel)]="entity.password"
                [ngClass]="
                  validationError && password.invalid ? 'errorInput' : ''
                "
                class="form-control form-control-sm"
              />
              <div
                *ngIf="validationError && password.invalid"
                class="errorMessage"
              >
                {{ "important_area" | translate }}
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="current_account" class="col-md-4 col-sm-12">
              <small>{{ "current_account" | translate }}</small>
            </label>
            <div class="col-md-8 col-sm-12">
              <div class="input-group">
                <input
                  class="form-control form-control-sm"
                  [disabled]="true"
                  [value]="entity.current_account?.description"
                  [ngClass]="
                    validationError && !entity.current_account
                      ? 'errorInput'
                      : ''
                  "
                  id="current_account"
                  name="current_account"
                />
                <a
                  class="inputClear"
                  [hidden]="!entity.current_account || isReadOnly"
                  (click)="clearCurrentAccount()"
                >
                  <i class="fal fa-close"></i>
                </a>
                <div
                  class="input-group-append"
                  (click)="!isReadOnly ? setModal() : ''"
                >
                  <span
                    class="input-group-text transparent"
                    id="basic-addon342"
                  >
                    <i class="fal fa-ellipsis-h" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
              <div
                *ngIf="validationError && !entity.current_account"
                class="errorMessage"
              >
                {{ "important_area" | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</kl-form-container>
